import { ILineBreakOption } from '../../interface/LineBreak'

export const defaultLineBreak: Readonly<Required<ILineBreakOption>> = {
  disabled: true,
  color: '#CCCCCC',
  lineWidth: 1.5
}
